import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9a350e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "concent" }
const _hoisted_2 = { class: "logout-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Your request has been submitted ", -1))
const _hoisted_4 = { class: "logout-content logout-bottom" }
const _hoisted_5 = { class: "logout-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You requested the permanent closure of your Kilimall account and the complete deletion of your data. Once your request is processed and your account closed, all products and services that you access through your account will no longer be available. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text2" }, " Please take into consideration that your account will still be active while our customer relations teams are processing your request, but you cannot place an order or apply for after-sales service during this period. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text2" }, " This may take up to 7 days from the date of submission of your request. ", -1))
const _hoisted_9 = { class: "text2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" The protection period will end on ")
const _hoisted_11 = { class: "text-color" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" at which time the system will automatically execute the account closing procedure. ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text2" }, " During this period, if you regret it, you can cancel the closure application: ", -1))
const _hoisted_14 = {
  key: 0,
  class: "logout-button-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString($setup.monthDay) + ", " + _toDisplayString($setup.yearDate) + ",", 1),
            _hoisted_12
          ]),
          _hoisted_13
        ]),
        ($setup.cancellationInfo?.cancel_state !== 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "logout-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleCancelAppicationClick && $setup.handleCancelAppicationClick(...args)))
              }, " Cancel application ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}